import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { FormGroup, FormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { ApiService } from 'src/app/services/api.service';
import { ErrorText } from 'src/app/enums/error-text.enum';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'fury-edit-lead-partner-content',
  templateUrl: './edit-lead-partner-content.component.html',
  styleUrls: ['./edit-lead-partner-content.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class EditLeadPartnerContentComponent implements OnInit, OnDestroy {
  ngUnsubscribe = new Subject<void>();
  leadPartnerContentForm!:FormGroup;
  bannerImage:any;
  leadPartnerId:any;
  contentDetails:any;
  @ViewChild('image_one') private image_one: ElementRef;

  constructor(
    public apiservice: ApiService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public location: Location,
  ) {
  }

  ngOnInit(): void {
    this.activatedRoute.params.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
      this.leadPartnerId = res?.id;
      if(this.leadPartnerId){
        this.getPartnerDetails();
      }
    });
    this.formInit();
  }
  formInit() {
    this.leadPartnerContentForm = new FormGroup({
      partnerBadge: new FormControl('',),
      partnerOffer: new FormControl('',),
      partnerHeading: new FormControl('',),
      partnerDescription: new FormControl('',),
      recommendedCompany: new FormControl('',),
      recommendedText: new FormControl('',),
    });
  };
  getPartnerDetails(){
    this.apiservice.get('admin/lead-partner/get-lead-partner/'+ this.leadPartnerId).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res:any)=>{
      if(res?.body?.leadPartner){
        this.contentDetails = res.body?.leadPartner?.pageContents;
        this.bannerImage = res.body?.leadPartner?.pageContents?.partnerBadge
        this.leadPartnerContentForm.patchValue({
          partnerOffer: res.body?.leadPartner?.pageContents?.partnerOffer,
          partnerHeading: res.body?.leadPartner?.pageContents?.partnerHeading,
          partnerDescription: res.body?.leadPartner?.pageContents?.partnerDescription,
          recommendedCompany: res.body?.leadPartner?.pageContents?.recommendedCompany,
          recommendedText: res.body?.leadPartner?.pageContents?.recommendedText,
        });
      } 
    })
  }

  onImageUpload(event: any) {
    if (event.target.files[0].type === 'image/jpeg' || event.target.files[0].type === 'image/png' || event.target.files[0].type === 'image/jpg') {
      let file;
      file = event.target.files[0];
      this.leadPartnerContentForm.patchValue({ partnerBadge: file });
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.bannerImage = e.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    } else {
      this.apiservice.alert(ErrorText.ImageRestriction, 'error');
    }
  };
  editContent(){
    if(this.leadPartnerContentForm.valid){
      const data = new FormData();
      Object.keys(this.leadPartnerContentForm.value).forEach(fieldName => {
        if (this.leadPartnerContentForm.controls[fieldName].value) {
          data.append(fieldName, this.leadPartnerContentForm.value[fieldName]);
        }
      })

        this.apiservice.postMultiData(`admin/lead-partner/save-lead-partner-page-content/${this.leadPartnerId}`, data).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res:any)=>{
          if (res.body) {
            this.apiservice.alert(res.body?.message, ErrorType.Success);
            this.location.back();
          } else { this.apiservice.alert(res.body?.message, ErrorType.Warning); }
        }, err =>{
          this.apiservice.alert('Please try again', ErrorType.Error);
        })
    } else {
      this.leadPartnerContentForm.markAllAsTouched();
    }
  }
  removeBadge(){
    
    if(this.contentDetails?.partnerBadge){
      this.apiservice.delete(`admin/lead-partner/delete-lead-partner-badge/${this.leadPartnerId}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res:any)=>{
        if(res){
          this.getPartnerDetails();
        }
      }, err =>{
        this.apiservice.alert('Please try again', ErrorType.Error);
      })
    } else {
      this.leadPartnerContentForm.patchValue({
      partnerBadge: null
    });
    this.image_one.nativeElement.value = null;
    this.bannerImage = null;
    }
    
  }
  back() {
    this.location.back();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
